// extracted by mini-css-extract-plugin
module.exports = {"errorsList":"ErrorMessages_errorsList__3VK-9"};